import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ClientesService } from "../../../../services/clientes.service";
import { CreditosService } from "../../../../services/creditos.service";
/*App imports*/
import { HelpersService, TiposCreditos, EstatusCreditos } from '../../../../services/tools/helpers.service';

@Component({
  selector: 'clientes-creditos',
  templateUrl: './clientes-creditos.component.html',
  styleUrls: ['./clientes-creditos.component.scss']
})
export class ClientesCreditosComponent implements OnInit {

    @Input() public idClientes: number = null;
    @Input() public statusCredito: number = null;
    
    public listCreditos : any [] = [];
    public errors:any = {};
    public title : string = null;

    constructor(
      private clientesService: ClientesService,
      private helperService: HelpersService,
      private creditosService : CreditosService,
      private router: Router,
    ){
    }

    ngOnInit() {
    }

    public ngOnChanges(changes: SimpleChanges) {

        if (changes.statusCredito && this.statusCredito) {
            this.setupTitle(Number(this.statusCredito));    
        }
        
        if (this.idClientes && this.statusCredito) {
            this.getCreditos(this.idClientes, this.statusCredito);    
        }
    }

    private setupTitle(statusCredito : number){
        let title = null;
        switch(statusCredito){
            case EstatusCreditos.Pendiente:
                title = 'CRÉDITOS PENDIENTES';
                break;
            case EstatusCreditos.Vigente:
                title = 'CRÉDITOS VIGENTES';
                break;
            case EstatusCreditos.Finalizado:
                title = 'CRÉDITOS FINALIZADOS';
                break;
        }
        this.title = title;
    }

    private getCreditos(idClientes : number, statusCredito : number){
        let filters = {
            cliente : idClientes,
            status : statusCredito
            };
            
        this.creditosService.getAll(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content && jsonResult.content.data){
                    const jsonContent = response.json().content;
                    this.listCreditos = this.setupCreditLabels(jsonContent.data);
                }
            
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }
    
    private setupCreditLabels(listCreditos : any []){
        listCreditos.forEach(function(credito) {
            switch(credito.statusCredito){
            case EstatusCreditos.Pendiente:
                credito.statusLabel = 'Pendiente';
                break;
            case EstatusCreditos.Vigente:
                credito.statusLabel = 'Vigentes';
                break;
            case EstatusCreditos.Finalizado:
                credito.statusLabel = 'Finalizado';
                break;
            }
        });
        return listCreditos;
    }

    public selectCredito(credito : any){
        let creditoUrl = '';
        switch(credito.idTipos_Creditos){
            case TiposCreditos.Hipotecario:
            creditoUrl = '/creditos/hipotecario/detalles/';
            break;
            case TiposCreditos.Automotriz:
            creditoUrl = '/creditos/automotriz/detalles/';
            break;
            case TiposCreditos.Prendario:
            creditoUrl = '/creditos/prendario/detalles/';
            break;
            case TiposCreditos.Verde:
            creditoUrl = '/creditos/verde/detalles/';
            break;
            case TiposCreditos.Personal:
            creditoUrl = '/creditos/personal/detalles/';
            break;
            case TiposCreditos.Carburacion:
            creditoUrl = '/creditos/carburacion/detalles/';
            break;
            case TiposCreditos.Estacionario:
            creditoUrl = '/creditos/estacionario/detalles/';
            break;
        }
        this.router.navigate([creditoUrl, credito.id]);
    }

}


// WEBPACK FOOTER //
// ./src/app/clientes/detalles/components/creditos/clientes-creditos.component.ts